export default __webpack_public_path__ + "static/social-clusters-02caf1d351c9df9110c70131146779e8.png";